var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('filter-reservation',{attrs:{"outlets":_vm.outlets,"customers":_vm.customers},on:{"filter":function($event){return _vm.onFilter()}},model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('app-datatable',{attrs:{"title":_vm.$t('title.reservations_datatable'),"printUrl":_vm.$route(
								'tenant.reservations.print.index',
								_vm.$page.props.tenant.id,
								{
									params: {
										'filter[status]':
											this.filter.status,
										'filter[code]': this.filter.code,
										'filter[outlet]':
											this.filter.outlet,
										'filter[customer]':
											this.filter.customer,
									},
								}
							),"exportUrl":_vm.$route(
								'tenant.reservations.export.reservation',
								_vm.$page.props.tenant.id
							),"endpoint":_vm.endpoint,"data":_vm.data,"headers":_vm.headers,"filter":_vm.filter},on:{"onEdit":_vm.editItem,"onDelete":_vm.deleteItem,"onView":_vm.viewItem}})],1)],1)],1)],1),_vm._v(" "),_c('app-create-fab-button',{attrs:{"permission":'create reservations'},on:{"click":function($event){_vm.$inertia.visit(
				_vm.$route('tenant.reservations.create', _vm.$page.props.tenant.id)
			)}}}),_vm._v(" "),_c('app-tenant-delete-dialog',{ref:"deleteDialog",attrs:{"endpoint":'tenant.reservations.destroy',"uuid":_vm.item.uuid,"data":{
			reservation: _vm.item.uuid,
			tenant: _vm.$page.props.tenant.id,
		}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }